require('./build/loading-bar');
module.exports = 'angular-loading-bar';



//////////////////
// WEBPACK FOOTER
// ./~/angular-loading-bar/index.js
// module id = 263
// module chunks = 1